module.exports = __webpack_public_path__ + "mainassets/img/graf4.50e6d786.svg";